export enum NumberFormatOptions {
  Auto = 'auto',
  Dot = 'dot', // 1.000,00
  Comma = 'comma', // 1,000.00
}

export const numberFormatOptionToLabelMap: Record<NumberFormatOptions, string> =
  {
    [NumberFormatOptions.Auto]: 'Auto', // Dynamic part handled in hook
    [NumberFormatOptions.Dot]: '1.234.567,89',
    [NumberFormatOptions.Comma]: '1,234,567.89',
  };

export const initialNumberFormat = NumberFormatOptions.Auto;

export type NumberFormat = { decimal: string; group: string };

export const numberFormatSeparators: Record<NumberFormatOptions, NumberFormat> =
  {
    [NumberFormatOptions.Auto]: { decimal: '.', group: ',' }, // Default fallback
    [NumberFormatOptions.Dot]: { decimal: ',', group: '.' },
    [NumberFormatOptions.Comma]: { decimal: '.', group: ',' },
  };
